import React, {Fragment} from "react";
import {ConnectedReduxProps} from "@reducers/index";
import {Conductor} from "@models/conductor";
import ConductorForm from "@components/conductors/Form";
import {injectIntl} from "react-intl";
import conductorApi from "@api/conductor";


interface PropsFromState {
  loading: boolean;
  data: Conductor[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class ConductorFormPage extends React.Component<AllProps> {
  state = {
    conductor: null,
    conductor_id: this.props.match.params.id,
    is_fetched: false
  };

  componentDidMount() {
    if (this.state.conductor_id) {
      this.fetchItem();
    }
  }

  fetchItem = () => {
    conductorApi
      .getItem({
        params: {
          conductor_id: this.state.conductor_id,
        }
      })
      .then(({data}) => {
        this.setState({
          conductor: data
        });
      })
      .catch(error => {
      });
  };

  updateRequest = ({payload, params, onSuccessCallback, onErrorCallback, id}) => {
    conductorApi.update({
        payload,
        params:{
          conductor_id : params.id
        },
      })
      .then(({data}) => onSuccessCallback(data))
      .catch(error => onErrorCallback(error))
  };

  createRequest = ({payload, onSuccessCallback, onErrorCallback}) => {
    conductorApi.create({
        payload,
      })
      .then(({data}) => onSuccessCallback(data))
      .catch(error => onErrorCallback(error))
  };

  getContent = () => {
    if (this.state.conductor_id && !this.state.conductor) {
      return null;
    }

    return (
      <ConductorForm
        conductor={this.state.conductor}
        intl={this.props.intl}
        listUrl={"/conductors"}
        history={this.props.history}
        updateRequest={this.updateRequest}
        createRequest={this.createRequest}
      />
    );
  };

  render() {
    return <Fragment>{this.getContent()}</Fragment>;
  }
}


export default injectIntl(ConductorFormPage)
